import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import PageSectionHeading from '../../PageSectionHeading';
import CommunityCardVertical from '../../CommunityCardVertical';
import HomeCard from '../../HomeCard';
import PlanCard from '../../PlanCard';

const styles = css`
  padding: 30px 0;
  @media(min-width: 992px) {
    padding: 120px 0;
  }
  .TabMenu {
    margin: 0 0 30px 0;
    text-align: center;
    @media (min-width: 992px) {
      margin: 0 0 30px 0;
    }
  }
`;


class FeaturedProducts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: undefined,
    };
  }

  switchTabHandler = tab => {
    this.setState({
      tab,
    });
  }

  render() {
    const { communities, homes, plans, content } = this.props;
    const { tab = get(content, '[0]default_tab') } = this.state;
    const featuredCommunities = get(content, '[0].featured_communities', []).map(id => communities.find(c => c._id === id)).filter(v => v);
    const featuredHomes = get(content, '[0].featured_homes', []).map(id => homes.find(h => h._id === id)).filter(v => v);
    const featuredPlans = get(content, '[0].featured_plans', []).map(id => plans.find(p => p._id === id)).filter(v => v);

    return (
      <div className={styles}>
        {
          tab === 'communities' &&
          <PageSectionHeading h3={get(content, '[0].communities_heading')} />
        }
        {
          tab === 'homes' &&
          <PageSectionHeading h3={get(content, '[0].homes_heading')} />
        }
        {
          tab === 'plans' &&
          <PageSectionHeading h3={get(content, '[0].plans_heading')} />
        }
        <div className="container">
          {
            [
              featuredCommunities.length,
              featuredHomes.length,
              featuredPlans.length,
            ].filter(v => v).length > 1 &&
            <div className="TabMenu">
              {
                featuredCommunities.length > 0 &&
                <button
                  onClick={() => this.switchTabHandler('communities')}
                  tabIndex={0}
                  className={`tab ${tab === 'communities' ? 'active' : ''}`}
                >
                  Communities
                </button>
              }
              {
                featuredHomes.length > 0 &&
                <button
                  onClick={() => this.switchTabHandler('homes')}
                  tabIndex={0}
                  className={`tab ${tab === 'homes' ? 'active' : ''}`}
                >
                  Available Homes
                </button>
              }
              {
                featuredPlans.length > 0 &&
                <button
                  onClick={() => this.switchTabHandler('plans')}
                  tabIndex={0}
                  className={`tab ${tab === 'plans' ? 'active' : ''}`}
                >
                  Floor Plans
                </button>
              }
            </div>
          }
        </div>
        {
          tab === 'communities' &&
          featuredCommunities.length > 0 &&
          <div className="container">
            <div className="row justify-content-center">
              {
                featuredCommunities.map(community => (
                  <CommunityCardVertical community={community} key={community._id} />
                ))
              }
            </div>
            {
              get(content, '[0].communities_button_text') &&
              <div className="row justify-content-center">
                <Link name="communities" className="btn btn-brand3 mt-4">{get(content, '[0].communities_button_text')}</Link>
              </div>
            }
          </div>
        }
        {
          tab === 'homes' &&
          featuredHomes.length > 0 &&
          <div className="container">
            <div className="row justify-content-center">
              {
                featuredHomes.map(home => (
                  <HomeCard home={home} key={home._id} />
                ))
              }
            </div>
            {
              get(content, '[0].homes_button_text') &&
              <div className="row justify-content-center">
                <Link name="homes" className="btn btn-brand3 mt-4">{get(content, '[0].homes_button_text')}</Link>
              </div>
            }
          </div>
        }
        {
          tab === 'plans' &&
          featuredPlans.length > 0 &&
          <div className="container">
            <div className="row justify-content-center">
              {
                featuredPlans.map(plan => (
                  <PlanCard plan={plan} key={plan._id} />
                ))
              }
            </div>
            {
              get(content, '[0].plans_button_text') &&
              <div className="row justify-content-center">
                <Link name="plans" className="btn btn-brand3 mt-4">{get(content, '[0].plans_button_text')}</Link>
              </div>
            }
          </div>
        }
      </div>
    );
  }
}


FeaturedProducts.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
};

FeaturedProducts.defaultProps = {
};

export default withData({
  communities: 'all',
  homes: 'all',
  plans: 'all',
})(FeaturedProducts);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/FeaturedProducts.section.js